import { Controller } from "@hotwired/stimulus"
import { DeviceDataCollector } from "../device_data_collector"

export default class extends Controller {
  static targets = ["deviceData", "geolocationData", "submitButton"]

  connect() {
    this.collectDeviceData()
    this.requestGeolocation()
  }

  collectDeviceData() {
    const deviceData = DeviceDataCollector.collect()
    this.deviceDataTarget.value = JSON.stringify(deviceData)
  }

  requestGeolocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const geoData = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            timestamp: new Date().toISOString()
          }
          this.geolocationDataTarget.value = JSON.stringify(geoData)
        },
        (error) => {
          console.log("Geolocation not available:", error.message)
        }
      )
    }
  }

  handleSubmit(event) {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.value = "Enviando..."
    this.submitButtonTarget.classList.add('opacity-75', 'cursor-not-allowed')
  
    document.body.style.overflow = 'hidden'

    const overlay = document.createElement('div')
    overlay.className = 'fixed inset-0 bg-black/50 z-50 flex items-center justify-center'
    overlay.innerHTML = `
      <div class="text-center space-y-6">
        <!-- Loading Spinner -->
        <div class="flex justify-center">
          <div class="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
        </div>

        <span class="text-xl font-semibold text-white">
          Enviando termo...
        </span>
      </div>
    `

    document.body.appendChild(overlay)
  }
}
